/**
 * Created by Yair on 7/27/15.
 */

import 'backbone';
import _ from 'lodash-extended';

const _analytics = {};
_.extend(_analytics, Backbone.Events);

function track(message, defaultOptions = {}) {
  return function (options = {}) {
    if (!window.analytics) {
      return;
    }

    if (_.isObject(defaultOptions)) {
      options = Object.assign({}, defaultOptions, options);
    }

    if (
      !app.rootStore.getters['user/box'].isProd() ||
      localStorage.debug === 'true'
    ) {
      console.log(
        '%c 📊 Analytics Event: ' + message,
        'color: green',
        options || ''
      );
    }
    analytics.track(message, options);
  };
}

_analytics.on('analytics:page', function () {
  if (window.analytics) {
    analytics.page();
  }
});
_analytics.on('analytics:identify', function (id, userTraits) {
  if (!window.analytics || typeof analytics.identify !== 'function') {
    console.error('analytics:identify');
    return;
  }
  this.userTraits = userTraits;
  analytics.identify(id, userTraits);
});

_analytics.on('analytics:vo:recorded', track('Recorded VO', 'ajax response'));

_analytics.on('analytics:vo:uploaded', track('Uploaded VO', 'ajax response'));

_analytics.on(
  'analytics:newStory:fromText',
  track('Started from Text', 'click')
);

_analytics.on(
  'analytics:newStory:fromMedia',
  track('Started from Media', 'click')
);

_analytics.on(
  'analytics:newStory:fromExisting',
  track('Started from Existing', 'click')
);

_analytics.on(
  'analytics:video:started',
  track('Started a Video', 'server polling')
);

// _analytics.on('analytics:video:published', track('Published a Video', 'server polling'));

_analytics.on('analytics:chose:voiceover', track('Chose Voiceover'));
_analytics.on('analytics:chose:noVoiceover', track('Chose No Voiceover'));

_analytics.on('analytics:search:media', track('Search Media'));

_analytics.on(
  'analytics:mediaSelection:OKFilters',
  track('Clicked OK Filters', 'click')
);
_analytics.on(
  'analytics:mediaSelection:selectedFilter',
  track('Selected Filter', 'click')
);
_analytics.on(
  'analytics:mediaSelection:selectedFolder',
  track('Selected Folder In Media Gallery', 'click')
);
_analytics.on(
  'analytics:mediaSelection:selectedTab',
  track('Selected Tab in Media Gallery', 'click')
);
_analytics.on(
  'analytics:mediaSelection:searchedMedia',
  track('Searched Media', 'click')
);
_analytics.on(
  'analytics:mediaSelection:quickAddAssets',
  track('Quick Added Asset from Media Gallery', 'click')
);
_analytics.on(
  'analytics:mediaSelection:addAssets',
  track('Selected Asset from Media Gallery', 'click')
);
_analytics.on(
  'analytics:mediaSelection:openLightbox',
  track('Opened Lightbox')
);
_analytics.on(
  'analytics:mediaSelection:closeLightbox',
  track('Closed Lightbox')
);
_analytics.on(
  'analytics:mediaSelection:sort',
  track('Sorted Media Gallery', 'click')
);
_analytics.on(
  'analytics:mediaSelection:contentType',
  track('Selected Content Type', 'click')
);
_analytics.on(
  'analytics:mediaSelection:backToStart',
  track('Back to Start Page from Media Selection', 'click')
);
_analytics.on(
  'analytics:mediaSelection:goVO',
  track('Continued to VO question', 'click')
);
_analytics.on(
  'analytics:mediaSelection:clearHistory',
  track('Clear Search History', 'click')
);
_analytics.on(
  'analytics:mediaSelection:openUploadMedia',
  track('Opened Upload My Media Dialog', 'click')
);
_analytics.on(
  'analytics:mediaSelection:clickedUploadMedia',
  track('Clicked Upload Media', 'click')
);

_analytics.on(
  'analytics:mediaSelection:createdInfogx',
  track('Created Infographics')
);
_analytics.on(
  'analytics:mediaSelection:uploadedMyMedia',
  track('Uploaded My Media')
);
_analytics.on(
  'analytics:mediaSelection:uploadedMyMedia-Fail',
  track('Uploaded My Media Failed')
);
_analytics.on(
  'analytics:mediaSelection:uploadedYoutubeMedia',
  track('Uploaded My Youtube Media')
);
_analytics.on(
  'analytics:mediaSelection:uploadedYoutubeMedia-Fail',
  track('Uploaded My Youtube Media Failed')
);
_analytics.on(
  'analytics:mediaSelection:sharingSelectionPrivate',
  track('Sharing selection private')
);
_analytics.on(
  'analytics:mediaSelection:sharingSelectionShareWithTeam',
  track('Sharing selection share with team')
);
_analytics.on('analytics:mediaSelection:keywords', track('Add keywords'));
_analytics.on(
  'analytics:mediaSelection:withCredits',
  track('Credits with value')
);
_analytics.on(
  'analytics:mediaSelection:withOutCredits',
  track('Credits without value')
);
_analytics.on(
  'analytics:mediaSelection:searchTweets',
  track('Searched For Tweets')
);
_analytics.on(
  'analytics:mediaSelection:searchInstagram',
  track('Searched For Instagram')
);
_analytics.on(
  'analytics:mediaSelection:searchFacebook',
  track('Searched For Posts')
);
_analytics.on(
  'analytics:mediaSelection:twitterLogin',
  track('Connected with Twitter')
);
_analytics.on(
  'analytics:mediaSelection:instagramLogin',
  track('Connected with Instagram')
);

_analytics.on(
  'analytics:lightbox:removedAsset',
  track('Deleted Asset from Lightbox', 'click')
);
_analytics.on(
  'analytics:lightbox:scrolledRight',
  track('Scrolled Lightbox', 'click')
);
_analytics.on(
  'analytics:lightbox:scrolledLeft',
  track('Scrolled Lightbox', 'click')
);

_analytics.on('analytics:publish:click', track('Clicked Publish Video'));

_analytics.on('analytics:publish:continue', track('Clicked Continue Publish'));

_analytics.on('analytics:publish:downloadVideo', track('Downloaded Video'));

_analytics.on('analytics:story:saved:manually', track('Story Manually Saved'));
_analytics.on(
  'analytics:story:continuedFromDashboard',
  track('Continued a Story From Dashboard')
);

_analytics.on(
  'analytics:video:clickedFromDashboard',
  track('Clicked a Video From Dashboard')
);

_analytics.on(
  'analytics:story:deletedFromDashboard',
  track('Deleted a Story From Dashboard')
);

_analytics.on(
  'analytics:video:deletedFromDashboard',
  track('Deleted a Video From Dashboard')
);

_analytics.on(
  'analytics:settings:clickedChangePassword',
  track('Clicked Change Password')
);

_analytics.on(
  'analytics:settings:changedPersonalDetails',
  track('Changed Personal Details')
);

_analytics.on(
  'analytics:settings:setNotification',
  track('Notification was Set')
);

_analytics.on(
  'analytics:dashboard:selectedFolder',
  track('Selected Dashboard Folder')
);

_analytics.on(
  'analytics:startPage:searchedForTrending',
  track('Searched for Trending')
);
_analytics.on(
  'analytics:startPage:searchedForExisting',
  track('Searched for Existing')
);
_analytics.on(
  'analytics:startPage:startedFromExisting',
  track('Started from Existing')
);
_analytics.on(
  'analytics:startPage:backToTimelineFromExisting',
  track('Back to Timeline from Existing')
);
_analytics.on(
  'analytics:startPage:backToVOQuestionFromExisting',
  track('Back to VO Question from Existing')
);
_analytics.on(
  'analytics:startPage:reproduceFromExisting',
  track('Reproduce from Existing')
);
_analytics.on(
  'analytics:startPage:backToVOScriptingFromExisting',
  track('Back to VO Scripting from Existing')
);
_analytics.on(
  'analytics:startPage:backToVORecordingFromExisting',
  track('Back to VO Recording from Existing')
);
_analytics.on(
  'analytics:startPage:playedExistingVideo',
  track('Played Existing Video')
);
_analytics.on('analytics:startPage:backToExisting', track('Back to Existing'));
_analytics.on(
  'analytics:startPage:viewedAboutExistingVideo',
  track('Viewed About Existing Video')
);
_analytics.on(
  'analytics:startPage:startedFromMyMedia',
  track('Started from My Media')
);
_analytics.on(
  'analytics:startPage:startedFromMedia',
  track('Started from Media')
);
_analytics.on(
  'analytics:startPage:clickedDashboardFromStartPage',
  track('Clicked Dashboard from Start Page')
);

_analytics.on('analytics:assetEditor:cancel', track('Cancel Asset Editor'));
_analytics.on(
  'analytics:assetEditor:setAsThumbnail',
  track('Set as Thumbnail')
);
_analytics.on('analytics:assetEditor:setAsWiper', track('Set as Wiper'));
_analytics.on('analytics:assetEditor:savedEdits', track('Saved Edits'));
_analytics.on(
  'analytics:assetEditor:selectedTextOverlay',
  track('Selected Text Overlay')
);
_analytics.on(
  'analytics:assetEditor:selectedZoomIn',
  track('Selected Zoom In')
);
_analytics.on(
  'analytics:assetEditor:selectedZoomOut',
  track('Selected Zoom Out')
);
_analytics.on('analytics:assetEditor:selectedCredit', track('Selected Credit'));
_analytics.on('analytics:assetEditor:selectedSuper', track('Selected Super'));
_analytics.on(
  'analytics:assetEditor:selectedSubtitles',
  track('Selected Subtitles')
);
_analytics.on(
  'analytics:assetEditor:selectedCustomOverlay',
  track('Selected Custom Overlay')
);
_analytics.on(
  'analytics:assetEditor:clickedOriginalVideo',
  track('Clicked Original Video in Video Asset Editor')
);
_analytics.on('analytics:assetEditor:copyText', track('Copy Text'));
_analytics.on(
  'analytics:assetEditor:crop-scale-changed',
  track('Crop scale changed in layout page')
);
_analytics.on(
  'analytics:assetEditor:crop-offset-changed',
  track('Crop offset changed in layout page')
);
_analytics.on(
  'analytics:assetEditor:crop-scale-changed.primary',
  track('Crop scale changed in preview page')
);
_analytics.on(
  'analytics:assetEditor:crop-offset-changed.primary',
  track('Crop offset changed in preview page')
);
_analytics.on('analytics:assetEditor:crop-close', track('Crop Close'));
_analytics.on('analytics:assetEditor:crop-reset', track('Crop Reset'));
_analytics.on('analytics:assetEditor:crop-apply', track('Crop Apply'));

_analytics.on('analytics:videoTrimming:addSegment', track('Add Segment'));
_analytics.on('analytics:videoTrimming:playVideo', track('Play'));
_analytics.on('analytics:videoTrimming:resetScene', track('Click select all'));

/** *******************************************************************************************
 * BGMusic events
 */
// General
_analytics.on(
  'analytics:timeline:openedBGMusic',
  track('Opened BG Music Gallery')
);
_analytics.on(
  'analytics:timeline:closedBGMusic',
  track('Closed BG Music Gallery')
);
_analytics.on('analytics:timeline:removedBGMusic', track('Removed BG Music'));
// Around the tracks
_analytics.on('analytics:timeline:searchedBGMusic', track('Searched BG Music'));
_analytics.on(
  'analytics:timeline:filterBGMusic',
  track('BG Music Filter Applied')
);
_analytics.on('analytics:timeline:sortBGMusic', track('BG Music Sort'));
_analytics.on('analytics:timeline:uploadBGMusic', track('Upload Music File'));
// Track related
_analytics.on('analytics:timeline:replacedBGMusic', track('Replaced BG Music'));
_analytics.on(
  'analytics:timeline:unselectedBGMusic',
  track('Unselect BG Music')
);
_analytics.on('analytics:timeline:playedBGMusic', track('Played BG Music'));
_analytics.on(
  'analytics:timeline:favoritedBGMusic',
  track('Favorited BG Music')
);
_analytics.on('analytics:timeline:deletedBGMusic', track('Delete Music File'));
// ////////////////////////////////////////////////////////////////////////////////////////////

/** *******************************************************************************************
 * Discover/Storyboard events
 */
_analytics.on('discover:navigate', track('Click Start From Ready Made'));
_analytics.on('discover:preview', track('Watch Ready Made Video'));
_analytics.on('discover:clone', track('Ready Made Clone'));
_analytics.on('discover:rebrand', track('Ready Made Rebrand'));
// ...
_analytics.on('story:setAsStoryboard', track('Set as Storyboard'));
_analytics.on('dashboard:navigation', track('Select Tab in Dashboard'));
_analytics.on('discover:useStoryboard', track('Use Storyboard'));
_analytics.on('discover:navigateToBlog', track('See Storyboard Examples'));
_analytics.on('discover:sendToCMS', track('Send to CMS'));

// ////////////////////////////////////////////////////////////////////////////////////////////

_analytics.on('analytics:timeline:clickedPreview', track('Clicked Preview'));
_analytics.on('analytics:timeline:playedPreview', track('Played Preview'));
_analytics.on(
  'analytics:timeline:playedPreviewCache',
  track('Played Preview from Cache')
);
_analytics.on('analytics:timeline:changedCC', track('Changed CC'));
_analytics.on(
  'analytics:timeline:closeMediaGallery',
  track('Closed Media Gallery in Timeline')
);
_analytics.on(
  'analytics:timeline:clickedPlayerDisclaimer',
  track('Clicked Disclaimer on Player')
);
_analytics.on('analytics:timeline:clickedGetVideo', track('Clicked Get Video'));
_analytics.on('analytics:timeline:replaceAsset', track('Asset Replace'));

_analytics.on(
  'analytics:navigation:voiceOverQuestion2mediaSelection',
  track('Back to Media Selection from VO Question')
);
_analytics.on('analytics:sotPlacement:placedSot', track('Placed SOT'));
_analytics.on('analytics:sotPlacement:removedSOT', track('Removed SOT'));
_analytics.on(
  'analytics:sotPlacement:clickedGotIt',
  track('Clicked Got It in SOT Placement')
);
_analytics.on(
  'analytics:sotPlacement:doNotShow',
  track('Do Not Show in SOT Placement')
);

_analytics.on(
  'analytics:VOScripting:backToVOQuestion',
  track('Back to VO Question from Voice Over Scripting')
);
_analytics.on(
  'analytics:VOScripting:clickOriginalStory',
  track('Click Original Story')
);

_analytics.on(
  'analytics:publishScreen:viewedFailedProduce',
  track('Viewed Failed Produce')
);
_analytics.on(
  'analytics:publishScreen:clickedCreateNewInFailed',
  track('Clicked Create New in Failed')
);
_analytics.on(
  'analytics:publishScreen:clickedAboutThisVideo',
  track('Clicked About This Video')
);
_analytics.on(
  'analytics:publishScreen:clickedActionsInPublish',
  track('Clicked Actions in Publish')
);
_analytics.on(
  'analytics:publishScreen:playedVideoInPublish',
  track('Played Video In Publish')
);
_analytics.on(
  'analytics:publishScreen:clickedCreateNewFromHeader',
  track('Clicked Create New from Header')
);
_analytics.on(
  'analytics:publishScreen:clickedDashboardFromHeader',
  track('Clicked Dashboard from Header')
);
_analytics.on(
  'analytics:publishScreen:downloadedVideo',
  track('Downloaded Video')
);
_analytics.on(
  'analytics:publishScreen:downloadedThumbnail',
  track('Downloaded Thumbnail')
);
_analytics.on('analytics:publishScreen:uploadedVideo', track('Uploaded Video'));
_analytics.on(
  'analytics:publishScreen:clickedOnUpload',
  track('Clicked on Upload')
);
_analytics.on(
  'analytics:publishScreen:clickedMoreShare',
  track('Clicked More Share')
);
_analytics.on('analytics:publishScreen:clickedShare', track('Clicked Share'));
_analytics.on('analytics:publishScreen:sharedVideo', track('Shared Video'));
_analytics.on('analytics:publishScreen:copiedEmbed', track('Copied Embed'));
_analytics.on('analytics:publishScreen:copiedLink', track('Copied Link'));
_analytics.on(
  'analytics:publishScreen:clickedBackToTimelineInPublish',
  track('Clicked Back to Timeline in Publish')
);
_analytics.on(
  'analytics:publishScreen:segmentsEndOnBeat',
  track('Segments End on Beat')
);

_analytics.on(
  'analytics:publishScreen:clickedBackToMediaSelectionInPublish',
  track('Clicked Back to Media Selection in Publish')
);
_analytics.on(
  'analytics:publishScreen:clickContactUs',
  track('Contact Us in Pricing')
);

_analytics.on(
  'analytics:inAssetNavigation:prev',
  track('Click Previous Asset')
);
_analytics.on('analytics:inAssetNavigation:next', track('Click Next Asset'));

_analytics.on(
  'analytics:infogfxModal:select',
  track('Select Infographics Template')
);
_analytics.on(
  'analytics:infogfxModal:back',
  track('Back from Infographics Templates')
);
_analytics.on(
  'analytics:infogfxModal:preview',
  track('Generate Infographic Preview')
);
_analytics.on(
  'analytics:infogfxModal:preview:error',
  track('Error on Preview Infographic')
);
_analytics.on('analytics:infogfxModal:save', track('Clicked Save Infographic'));
_analytics.on(
  'analytics:infogfxModal:save:error',
  track('Error on Save Infographic')
);
_analytics.on(
  'analytics:infogfxModal:close',
  track('Close Infographic Editor')
);

_analytics.on(
  'analytics:aspectRatioView:change',
  track('Aspect Ratio Changed')
);

_analytics.on('analytics:textOverlay:add', track('Text Overlay Added'));
_analytics.on('analytics:textOverlay:delete', track('Text Overlay Deleted'));
_analytics.on(
  'analytics:textOverlay:textOverlayCommand',
  track('Text Overlay Command')
);
_analytics.on(
  'analytics:textOverlay:toggleCase',
  track('Text Overlay Case Toggle')
);
_analytics.on('analytics:textOverlay:rotate', track('Text Overlay Rotated'));
_analytics.on('analytics:textOverlay:saveStyle', track('Text Style Saved'));
_analytics.on('analytics:textOverlay:applyStyle', track('Text Style Applied'));
_analytics.on(
  'analytics:textOverlay:applySubStyle',
  track('Text SubStyle Applied')
);
_analytics.on(
  'analytics:textOverlay:overrideBoxDesign',
  track('Text Style Box Design Toggle')
);
_analytics.on(
  'analytics:textOverlay:overridePosition',
  track('Text Style Position Toggle')
);
_analytics.on(
  'analytics:textOverlay:textStyleEdited',
  track('Text Style Edited')
);
_analytics.on(
  'analytics:textOverlay:textStyleDeleted',
  track('Text Style Deleted')
);
_analytics.on(
  'analytics:textOverlay:totChanged',
  track('Text Overlay Timing Changed')
);
_analytics.on('analytics:textOverlay:copyText', track('Copy Text'));
_analytics.on('analytics:textOverlay:pasteText', track('Paste Asset'));

_analytics.on(
  'analytics:invitations:clickOnAvatar',
  track('Clicked on Invite avatar')
);
_analytics.on(
  'analytics:invitations:clickOnInvite',
  track('Clicked on Invite button')
);
_analytics.on(
  'analytics:invitations:productionLineChanged',
  track('Invite Production lines status change')
);
_analytics.on(
  'analytics:invitations:back',
  track('Click on the Invite back button', 'click')
);

_analytics.on('analytics:segmentation:add', track('Segment: Add'));
_analytics.on('analytics:segmentation:delete', track('Segment: Delete'));
_analytics.on('analytics:segmentation:recordPressed', track('Segment: Record'));
_analytics.on(
  'analytics:segmentation:recordReplace',
  track('Segment: Record Replaced')
);
_analytics.on(
  'analytics:segmentation:micSelectionChange',
  track('Segment: mic selection changed')
);
_analytics.on(
  'analytics:segmentation:uploadPressed',
  track('Segment: File Changed')
);
_analytics.on(
  'analytics:segmentation:uploadReplace',
  track('Segment: File replaced')
);
_analytics.on('analytics:segmentation:error', track('Segment: Error'));
_analytics.on(
  'analytics:segmentation:moveToNarration',
  track('Segment: Move to Wochit narration')
);

_analytics.on('analytics:dashboard:newVideo', track('Click Create New Video'));

_analytics.on('analytics:makeCopy:storyDone', track('Copy Story'));

// MASTHEAD
_analytics.on('masthead:makeNewWochit', track('Clicked Button Make a Wochit'));
_analytics.on('masthead:makeAiStory', track('Clicked Button Wochit AI Wizard'));

// METADATA EDITOR
_analytics.on('thumbnailPicker:opened', track('Clicked adjust thumbnail'));
_analytics.on(
  'thumbnailPicker:select',
  track('Clicked select asset thumbnail')
);

// FULL PREVIEW
_analytics.on('fullPreview:captureSnapshot', track('Captured thumbnail'));

// OTHERS
_analytics.on('clickedStartNewVideo', track('Clicked Start New Video'));
_analytics.on('clickedCollageSupport', track('Open Collage Support'));
_analytics.on('clickedGenerateAiDraft', track('Clicked Generate AI Draft'));
_analytics.on(
  'clickedGenerateAiTimeline',
  track('Clicked Generate AI Timeline')
);
_analytics.on('generateAiStoryGen2', track('Generate AI Story Gen2'));
// POST V8

_analytics.on('analytics:dashboard:openStory', track('Open Story'));
_analytics.on(
  'analytics:dashboard:playProducedVideo',
  track('Play Produced Video')
);
_analytics.on('analytics:dashboard:deleteStory', track('Delete Story'));
_analytics.on('analytics:dashboard:deleteVideo', track('Delete Video'));
_analytics.on('analytics:dashboard:search', track('Search Dashboard'));
_analytics.on('analytics:dashboard:filters', track('Filtered Dashboard'));

_analytics.on('analytics:versions:pageOpened', track('Open Version History'));
_analytics.on('analytics:versions:openVersion', track('Open Story Version'));
_analytics.on('analytics:versions:branch', track('Branch Story Version'));
_analytics.on('analytics:versions:delete', track('Delete Story Version'));

_analytics.on('analytics:assetGallery:search', track('Search Media'));
_analytics.on(
  'analytics:assetGallery:searchWochit',
  track('Search Media in Wochit Gallery')
);
_analytics.on(
  'analytics:assetGallery:searchMyGallery',
  track('Search Media in My Gallery')
);

_analytics.on('analytics:secondhand:grab', track('Grab Playhead'));
_analytics.on('analytics:favorite:favorite', track('Mark asset as favorite'));
_analytics.on(
  'analytics:favorite:unfavorite',
  track('Unmark asset as favorite')
);
_analytics.on('analytics:favorite:toggleMyFavorite', track('My Favorites'));

_analytics.on('transitions:auto:transitions', track('Auto Transitions'));
_analytics.on('transitions:lock:transition', track('Lock Transition'));

// produce
_analytics.on('produce:close', track('Close Produced Video'));

// Scenes
_analytics.on(
  'analytics.scenes.enterSceneEditMode',
  track('Enter Scene Edit Mode')
);
_analytics.on('analytics.scenes.openSceneEditor', track('Open Scene Editor'));
_analytics.on(
  'analytics.scenes.exitSceneEditMode',
  track('Exit Scene Editing on Timeline')
);
_analytics.on(
  'analytics.scenes.compositionChanged',
  track('Collage Composition Changed')
);
_analytics.on('analytics.scenes.clickedCrop', track('Clicked Crop'));
_analytics.on('analytics.scenes.clickedSwap', track('Clicked Swap'));
_analytics.on(
  'analytics.scenes.internalPageExit',
  track('Scene Editor internal pages exit')
);
_analytics.on(
  'analytics.scenes.confirmBack',
  track('Scene Editor confirm back to main')
);
_analytics.on('analytics.scenes.openLayoutPage', track('Open Layouts Page'));

_analytics.on('analytics:audio:mute', track('Asset Editor Mute Audio'));
_analytics.on('analytics:audio:audioSettings', track('Audio settings'));

// multilogin
_analytics.on('multilogin:foundSeatTaken', track('Found Seat Taken'));
_analytics.on('multilogin:foundSeatUnused', track('Found Seat Unused'));
_analytics.on('multilogin:kickedFromSeat', track('Kicked From Seat'));
_analytics.on(
  'multilogin:tampering',
  track('Suspected in Tampering With Account Seats')
);

// face on camera
_analytics.on('record:init', track('Initiate Record Video'));
_analytics.on('record:upload', track('Upload Recorded Video'));
_analytics.on('record:reset', track('Restart Recording'));
_analytics.on('record:download', track('Download Recording'));

// third part uploads
_analytics.on('dropbox-upload', track('Uploaded Files From Dropbox'));
_analytics.on('onedrive-upload', track('Uploaded Files From OneDrive'));

// VO - voice over
_analytics.on('VO:startRecordingAudio', track('start recording audio'));
_analytics.on('VO:saveRecordedAudio', track('save recorded audio'));
_analytics.on('VO:openTranscriptModal', track('open transcript modal'));
_analytics.on('VO:splitAudio', track('split audio'));
_analytics.on('VO:trimAudio', track('trim audio'));
_analytics.on('VO:editTranscript', track('edit transcript'));
_analytics.on('VO:insertTranscript', track('insert transcript'));
_analytics.on('VO:resetToOriginalScript', track('reset to original script'));
_analytics.on(
  'VO:autoTranscribeSelfUpload',
  track('Request transcript on upload')
);

// BG Music Beats
_analytics.on('bgMusicBeats:modeChange ', track('Show beats'));

// export track
_analytics.$track = track;
export default _analytics;
